import { ToastTypes, launchToast } from '../../../components'
import { useApiMutation } from '../../../utils'
import {
    SetDeviceForceUpdateMutationSchema,
    SetDeviceForceUpdateMutationVariablesSchema,
    type SetDeviceForceUpdateMutationVariables
} from '../device_schemas'

export const useSetDeviceForceUpdate = (callbackOnCompleted?: () => void) => {
    const { mutateAsync, isPending: loadingForceUpdate } = useApiMutation<
        SetDeviceForceUpdateMutationVariables,
        typeof SetDeviceForceUpdateMutationSchema
    >('/platform/device/set_device_force_update', SetDeviceForceUpdateMutationSchema)

    const setDeviceForceUpdate = async (input: SetDeviceForceUpdateMutationVariables) => {
        const variables = SetDeviceForceUpdateMutationVariablesSchema.parse(input)
        try {
            const data = await mutateAsync(variables)
            callbackOnCompleted?.()
            launchToast(ToastTypes.Success, 'Successfully force updated config!')
            return data
        } catch (error) {
            launchToast(ToastTypes.Error, 'Error: Could not save config. Check the console for more details !')
            console.error(error)
            throw error
        }
    }

    return { setDeviceForceUpdate, loadingForceUpdate }
}
